// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ContentComponentItemFragmentDoc } from '../../components/cms/component/ContentComponentItem.fragment.generated';
export const TooltipFragmentDoc = gql`
    fragment tooltip on Tooltip {
  title
  content {
    ...contentComponentItem
  }
}
    ${ContentComponentItemFragmentDoc}`;